import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { environment } from 'environments/environment';
import { JwtService } from './jwt.service';
import { lastValueFrom } from 'rxjs';

/* eslint-disable @typescript-eslint/naming-convention */
const SESSION_KEY = 'ADMIN_SESSION';

@Injectable()
export class JournalService extends HttpDataService {
  public jobId: string = '';
  public currentJob: string = '';

  constructor(protected injector: Injector, protected jwtService: JwtService) {
    super(injector, '/journal');
  }

  bootstrap() {
    if (environment.journal && environment.journal.agent) {
      const journalAgent = document.createElement('script');
      journalAgent.setAttribute('src', environment.journal.agent);
      journalAgent.onload = () => {
        if ('GLJournal' in window) {
          window['GLJournal']['bootstrap']({ serviceId: environment.SERVICE_ID, url: environment.journal.url });
        }
      };
      document.head.appendChild(journalAgent);
    }
  }

  dispatchStartSession() {
    const currentCookie = this.jwtService.loadSessionToken();
    if (currentCookie) {
      const [signature] = currentCookie.split('.').reverse();
      const currentSession = sessionStorage.getItem(SESSION_KEY);
      if (signature !== currentSession) {
        const payload = {
          verb: 'app_started',
          object: {
            origin: { id: environment.SERVICE_ID, label: 'admin' }
          }
        };
        this._fireEvent(payload);
        sessionStorage.setItem(SESSION_KEY, signature);
      }
    }
  }

  checkGroupStatements(groupId: string): Promise<any> {
    return lastValueFrom(this.http.get(`${this.baseUrl}/group/${groupId}`)).then((response) => response);
  }

  _fireEvent(payload) {
    document.dispatchEvent(new CustomEvent('journal', { detail: payload }));
  }
}
